/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { StorageModule } from '@vlinder-web/storage-module-react';

const MODULE_NAME = 'profile.machines.states.resend';

const getSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const checkUserLogin = async (context: any, event: any) => {
  const currentState = 'CHECK_USER_LOGIN';
  const method = 'checkUserLogin';

  return new Promise(async (resolve, reject) => {
    let storageSrv = StorageModule?.getInstance();

    try {
      let _user = await getSrv()?.whoAmI();
      let _sessionToken = storageSrv.get('userProfile', 'session')?.accessToken;
      let _localToken = storageSrv.get('userProfile', 'local')?.accessToken;
      let _token = _localToken ?? _sessionToken;
      console.log(`user Role`, _user);
      if (
        (_user.whoami === 'purchaser' || _user?.whoami === 'TELLER') &&
        _token
      ) {
        return resolve({
          key: 'CHECK_USER_LOGIN',
          value: {
            ...(_user || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        return reject({
          key: 'CHECK_USER_LOGIN',
          value: msg,
        });
      }
    } catch (err: any) {
      return reject({
        key: 'CHECK_USER_LOGIN',
        value: err?.message,
      });
    }
  });
};
